















































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import AWS from 'aws-sdk'
import { mixins } from 'vue-class-component'

import { FileToSave, File } from '@/modules/File/interfaces/file'
import { TicketAttachment } from '@/modules/Ticket/interfaces/ticket-attachment'
import { TicketDetail } from '@/modules/Ticket/interfaces/ticket'
import { STSCredential } from '@/interfaces/sts-credential'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { fileSizeFormat } from '@/utils/fileSize'
import S3Handler from '@/mixins/s3'

@Component
export default class AppMarkdownEditor extends mixins(S3Handler) {
  @Prop({ type: Boolean, default: false }) readonly preview!: boolean
  @Prop() readonly value!: TicketDetail
  @Prop({ type: Boolean, default: true }) readonly hasBorder!: boolean
  @Prop({ type: String, default: '#E1E7F0' }) readonly borderColor!: string

  toolbars: {
    [key: string]: boolean
  } = {
    bold: true, // 粗体
    italic: true, // 斜体
    header: true, // 标题
    underline: true, // 下划线
    strikethrough: true, // 中划线
    mark: true, // 标记
    superscript: true, // 上角标
    subscript: true, // 下角标
    quote: true, // 引用
    ol: true, // 有序列表
    ul: true, // 无序列表
    link: true, // 链接
    imagelink: false, // 图片链接
    code: true, // code
    table: true, // 表格
    fullscreen: false, // 全屏编辑
    readmodel: true, // 沉浸式阅读
    htmlcode: false, // 展示html源码
    help: true, // 帮助
    /* 1.3.5 */
    undo: true, // 上一步
    redo: true, // 下一步
    trash: true, // 清空
    save: false, // 保存（触发events中的save事件）
    /* 1.4.2 */
    navigation: false, // 导航目录
    /* 2.1.8 */
    alignleft: true, // 左对齐
    aligncenter: true, // 居中
    alignright: true, // 右对齐
    /* 2.2.1 */
    subfield: false, // 单双栏模式
    preview: true // 预览
  }

  text = ''
  files: TicketAttachment[] = []
  filesToDel: number[] = []
  filesToSave: FileToSave[] = []

  model: TicketDetail = {
    text: '',
    files: [],
    filesToDel: [],
    filesToSave: [],
    editting: false
  }

  fileType = ''
  fileUploadedSize: number = 0
  awsS3Prefix = process.env.VUE_APP_S3_URL
  bucketPrefix = process.env.VUE_APP_BUCKET_PREFIX

  stsCredential: STSCredential | null = null

  filesLoading = false

  acceptFileTypes = `
    .doc, .docx, .xml, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    application/pdf, image/*
  `

  fileSizeFormat = (size: any) => fileSizeFormat(size)

  fileDownloadLoading = false

  get openView () {
    return this.preview ? 'preview' : 'edit'
  }

  get showToolbas () {
    return !this.preview
  }

  mounted () {
    this.model = this.value

    this.$el.addEventListener('dragenter', (e) => {
      e.preventDefault()
    }, true)

    this.$el.addEventListener('dragover', (e) => {
      e.preventDefault()
    }, true)

    this.$el.addEventListener('paste', (e: any) => {
      this.onFilePaste(e)
    }, true)

    this.$el.addEventListener('drop', (e: any) => {
      e.preventDefault()
      e.stopImmediatePropagation()
    }, true)
  }

  @Watch('model', { deep: true })
  onModelChanged (val: any) {}

  @Watch('value', { deep: true })
  onValueChanged (val: any) {
    this.filesToSave = val.filesToSave
    this.model = val
  }

  @Watch('content')
  onTextChanged (val: string) {
    this.text = val
    this.valueChangedHandler(val)
  }

  @Watch('attachments')
  onFilesChanged (val: TicketAttachment[]) {
    this.files = val
  }

  @Watch('filesInfo', { deep: true })
  onFileInfoChanged (val: any) {
    let { filesToSave } = this
    if (val.length !== 0) {
      this.filesLoading = false
      filesToSave = this.filesInfo
      this.model.filesToSave = filesToSave
    }
  }

  async onFilePaste (e: ClipboardEvent) {
    var clipboardData = e.clipboardData
    if (clipboardData) {
      const items = clipboardData.items
      if (!items) return
      let types = clipboardData.types || []
      let item = null
      for (var i = 0; i < types.length; i++) {
        if (types[i] === 'Files') {
          item = items[i]
          break
        }
      }
      if (item && item.kind === 'file') {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  }

  @Emit('contentChanged')
  valueChangedHandler (val: string) {
    this.text = val
    return val
  }

  removeFile (index: number, type: string) {
    const { files, filesToSave } = this.model
    if (type === 'files') {
      this.model.files = this.$R.remove(index, 1, files)
    } else {
      this.model.filesToSave = this.$R.remove(index, 1, filesToSave)
    }
  }

  addFile () {
    const elem = this.$refs.fileBrowser as Vue & { click: () => boolean, value: string | null }
    elem.value = null
    elem.click()
  }

  async onFileChanged (e: any) {
    let files = e.target.files || e.dataTransfer.files
    this.filesToUpload = files
    this.filesLoading = true

    if (!this.checkCredentialValid()) {
      await this.getSTSCredentials()
    }

    this.filePrefix = 'tickets'

    const jobs = []

    for (let i = 0; i < files.length; i++) {
      jobs.push(this.uploadFileToS3(i))
    }

    await Promise.all(jobs)
  }

  async downloadFileHandler (file: any) {
    this.fileDownloadLoading = true
    await this.downloadFile(file)
    this.fileDownloadLoading = false
  }
}
